import React from 'react'
import { listOportunidadesByPublished } from '../services/oportunidadesService'
import type { OpportunityItem } from '../types'

export function useOportunidadesRevisao() {
  const [items, setItems] = React.useState<OpportunityItem[]>([])
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState<string | null>(null)

  const refresh = React.useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const rows = await listOportunidadesByPublished(false)
      setItems(rows)
    } catch (e: any) {
      setError(e?.message || 'Falha ao carregar oportunidades em revisão')
    } finally {
      setLoading(false)
    }
  }, [])

  React.useEffect(() => { refresh() }, [refresh])
  React.useEffect(() => {
    const cb = () => refresh()
    window.addEventListener('opportunities:refresh', cb)
    return () => { window.removeEventListener('opportunities:refresh', cb) }
  }, [refresh])

  return { items, loading, error, refresh }
}
